<lib-gestion-contrat [configuration]="configuration"></lib-gestion-contrat>
